import { LayoutAuth } from "../layout";
import { FormLogin } from "../pages/Login";


export const pathPublic = {
	auth: "auth",
	reset: "reset",
};

export const routerPublic = {
	element: <LayoutAuth />,
	path: pathPublic.auth,
	children: [
		{
			index: true,
			element: <FormLogin />,
		},
		// {
		// 	path: pathPublic.reset,
		// 	element: <TemplateHeader />,
		// },
	],
};
